<template>
  <v-container :class="containerClass" fluid>
    <subscription-order-form
      mode="edit"
      :subscription-order="subscriptionOrder.data"
      @cancel="onCancel"
    >
      <template #header>
        <div class="d-flex align-center">
          <v-btn
            icon
            color="primary"
            class="mr-2"
            :href="$route('subscription-orders.index')"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <h2>Edit {{ subscriptionOrder.data.code }}</h2>
        </div>
      </template>
    </subscription-order-form>
  </v-container>
</template>
<script>
import LayoutDashboard from '@layouts/Dashboard'
import SubscriptionOrderForm from '@components/SubscriptionOrder/Form'
export default {
  components: {
    SubscriptionOrderForm,
  },
  layout: LayoutDashboard,
  props: {
    subscriptionOrder: {
      type: Object,
      required: true,
    },
  },
  methods: {
    onCancel() {
      window.location.href = this.$route('subscription-orders.index')
    },
  },
}
</script>
